/* angular:styles/component:scss;920daecc406713e6809064829d633615cf405cecb87dc2a222650bf98c1d29e6;D:\Techriff-Project\3amautocare\Autocare.Api\ClientApp\src\app\module\users\types\formly-field-file-upload.component.ts */
.top {
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
}
#click {
  color: var(--Brand-700, #d47500);
}
.svg {
  color: var(--Gray-600, #475467);
  text-align: center;
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
}
.file-upload {
  border: 2px dashed #e4e7ec;
  padding: 16px 24px;
  text-align: center;
  cursor: pointer;
  transition: border-color 0.3s ease;
  height: 287px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  border-radius: 8px;
}
.file-upload-hover {
  border-color: #ff9f2a;
}
.file-upload:hover {
  border-color: #ff9f2a;
}
.file-upload p {
  margin: 0;
  color: #666;
}
.uploaded-image {
  max-width: 463px;
  max-height: 255px;
  margin-bottom: 10px;
}
.remove-button {
  background: none;
  border: none;
  color: #b42318;
  cursor: pointer;
  font-size: 14px;
  top: 110px;
  position: absolute;
  right: 30px;
}
.spinner-container {
  display: flex;
  flex-direction: column;
  align-items: center;
}
.spinner {
  border: 4px solid #ff8c00;
  border-top: 4px solid #ff8c00;
  border-radius: 50%;
  width: 58px;
  height: 58px;
  animation: spin linear infinite;
}
@keyframes spin {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
.progress-text {
  margin-top: 10px;
  font-size: 14px;
  font-weight: 600;
  color: #ff8c00;
}
/*# sourceMappingURL=formly-field-file-upload.component-IK6RM7BO.css.map */
